import { DvaModelBuilder, actionCreatorFactory } from 'dva-model-creator';
import { ContactType } from '@/common/type';
import { getLeadTypes } from '@/services/lead';

export const LEAD_OPTIONS_TTL = 1000 * 60 * 60;

export interface LeadModel {
  loadingTypes?: boolean;
  types?: ContactType[] | null;
}

const actionCreator = actionCreatorFactory('lead');
const loadTypes = actionCreator('loadTypes');
const saveData = actionCreator<{
  types?: ContactType[];
  loadingTypes?: boolean;
}>('saveData');

const initState: LeadModel = {
  loadingTypes: false,
  types: null,
};

export default new DvaModelBuilder(initState, 'lead')
  .takeEvery(loadTypes, function*(_, { call, put }) {
    // const response: ContactType[] | { [keys: string]: any } = yield call(getLeadTypes);

    // 使用mock数据替代API调用
    const response: ContactType[] = [
      { id: 1, value: 'shipper' },
      { id: 2, value: 'consignee' },
      { id: 3, value: 'carrier' },
      { id: 4, value: 'agent' },
      { id: 5, value: 'forwarder' },
      { id: 6, value: 'broker' },
      { id: 7, value: 'warehouse' },
      { id: 8, value: 'trucker' },
      { id: 9, value: 'other' },
    ];

    if (response && response.length !== undefined) {
      yield put(
        saveData({
          types: response
            .sort((a, b) => {
              return a.value.localeCompare(b.value);
            })
            .map(item => {
              item.value = item.value.replace(/(?:^|\s)\S/g, a => a.toUpperCase());
              return item;
            }) as ContactType[],
          loadingTypes: false,
        }),
      );
    } else {
      yield put(
        saveData({
          loadingTypes: false,
        }),
      );
    }
  })
  .case(saveData, (state, data) => ({
    ...state,
    ...data,
  }))
  .build();

export const actions = {
  loadTypes,
  saveData,
};
